import React, { useEffect, useRef, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';

import staff_img from '../../../../images/staff/staff_1.png';
import axios from 'axios';

const ComplaintsSubscription = ({ show, onClose, data }) => {

    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [hasFetchedComplaints, setHasFetchedComplaints] = useState(false);
    const [complaintData, setComplaintdata] = useState([]);
    const [convo, setconvo] = useState({ conversation: [] });
    // const [complaints, setComplaints] = useState([]);

    const fetchcomplaint = () => {
        axios.get(`${baseURL}/complaint/subscribers/${data.subscriber}`)
            .then(response => {
                setComplaintdata(response.data.data);
                setHasFetchedComplaints(true);
            })
            .catch(error => {
                console.log('There was an error fetching the data!', error);
                setHasFetchedComplaints(true);
            });
    }

    // fetch data & leadstatus
    useEffect(() => {
        if (data) {
            fetchcomplaint();
        }
    }, [data]);

    // useEffect (() => {
    //     if (complaintData) {
    //         setComplaints(complaintData.map((complaint, index) => {
    //             return ( { id: index, ...complaint } );
    //         }));

    //         // const parsedComplaint = {
    //         //     conversation: JSON.parse(complaintData.complaint.conversation || '[]')
    //         // };
    //         // setconvo(parsedComplaint);

    //     }
    // } ,[complaintData]);

    useEffect(() => {
        if (complaintData.length > 0) {
            const firstComplaint = complaintData[0]?.complaint;
            // const complaintMeta = complaintData[0];

            let conversation = [];

            // Try to parse stored conversation
            if (firstComplaint?.conversation) {
                try {
                    conversation = JSON.parse(firstComplaint.conversation);
                } catch (e) {
                    console.warn("Failed to parse conversation JSON", e);
                }
            }

            // // If conversation is empty, populate manually
            // if (conversation.length === 0) {
            //     conversation.push({
            //         complaint_type: complaintMeta.c_type_name || "Complaint",
            //         complaint: firstComplaint.complaint,
            //         datetime: firstComplaint.datetime,
            //     });

            //     if (firstComplaint.reason) {
            //         conversation.push({
            //             reason: firstComplaint.reason,
            //             reason_provider_name: firstComplaint.reason_provider_name,
            //             reason_datetime: firstComplaint.reason_datetime
            //         });
            //     }
            // }

            setconvo({ conversation });
        }
    }, [complaintData]);


    const chatScrollRef = useRef(null);

    useEffect(() => {
        if (chatScrollRef.current) {
        chatScrollRef.current.scrollTop = chatScrollRef.current.scrollHeight;
        }
    }, []);

    const formatDate = (date) => {
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = months[d.getMonth()];
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };

    return (
        <Modal show={show} size="lg"  >
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Subscription Complaint</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row mb-2">
                        <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-gray-800 font-w500 fs-7'>Subscriber</label>
                            <label className='text-black fs-6 font-w500'>{data.lead_name}
                            </label>
                        </div>
                        <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-gray-800 font-w500 fs-7'>Mobile No</label>
                            <label className='text-black fs-6 font-w500'>{data.lead_mobile_no}</label>
                        </div>
                        <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-gray-800 font-w500 fs-7'>Product</label>
                            <label className='text-black fs-6 font-w500'>{data.product_name}</label>
                        </div>
                        <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-gray-800 font-w500 fs-7'>Timeline</label>
                            <label className='text-black fs-6 font-w500'>{data.timeline_name} ( {data.timeline_days} Days )</label>
                        </div>
                        <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-gray-800 font-w500 fs-7'>Duration</label>
                            <div className='text-black fs-6 font-w500'>
                                <label className="text-success font-w500 fs-6">{formatDate(data.start_date)}</label>
                                <label className="text-black font-w500 fs-6 ms-1 me-1">/</label>
                                <label className="text-danger font-w500 fs-6">{formatDate(data.end_date)}</label>
                            </div>
                        </div>
                        <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-gray-800 font-w500 fs-7'>Area</label>
                            <label className='text-black fs-6 font-w500'>{data.area_name}</label>
                        </div>
                        <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-gray-800 font-w500 fs-7'>Delivery Point</label>
                            <label className='text-black fs-6 font-w500'>{data.deliverypoint_name ? data.deliverypoint_name : '-'}</label>
                        </div>
                        <div className='col-lg-8 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-gray-800 font-w500 fs-7'>Address</label>
                            <label className='text-black fs-6 font-w500'>{data.address ? data.address : '-'}</label>
                        </div>
                    </div>
                    
                    <div className='rounded border border-gray'>
                        <div className='text-center mb-0'>
                            <div className="bg-danger-light border-bottom text-black font-w600 fs-3">
                                <label className='mb-0'>Conversation</label>
                            </div>
                        </div>

                        {convo.conversation && convo.conversation.length > 0 ? (
                            <div className='scroll-y min-h-300px mh-300px px-3 py-2' ref={chatScrollRef} id="chat_scroll">
                                {convo.conversation.map((item, index) => {
                                    const isComplaint = !!item.complaint;
                                    const isEven = index % 2 === 0;

                                    // Common formatting
                                    const datetime = new Date(item.datetime || item.reason_datetime).toLocaleString("en-GB", {
                                        day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit',
                                        hour12: true
                                    });

                                    const date = new Date(item.datetime || item.reason_datetime).toLocaleString("en-GB", {
                                        day: '2-digit', month: 'short', year: 'numeric'
                                    });

                                    return (
                                        <>
                                            <div className="d-flex justify-content-center align-items-start mb-3">
                                                <div className="px-3 py-0 rounded fw-semibold text-start bg-gray-300">
                                                    <div className="d-flex align-items-center">
                                                        <label className="fs-8 font-w400 text-gray-800">{date}</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className={`d-flex ${isComplaint ? 'justify-content-start' : 'justify-content-end'} mb-3`} key={index}>
                                                <div className={`d-flex flex-column mw-50 ${isComplaint ? 'align-items-start' : 'align-items-end'}`}>
                                                    <div className={`px-2 py-1 rounded border ${isComplaint ? 'bg-danger-light text-danger border-danger text-start msg_recv' : 'bg-info-light text-info border-info msg_send'}`}>
                                                        {isComplaint && (
                                                        <>
                                                            <div className="d-block fs-8 font-w600 text-center"><u>{item.complaint_type || 'Complaint'}</u></div>
                                                            <div className="fs-8 font-w400 mb-1 text-black">{item.complaint}</div>
                                                            <div className="border-bottom border-danger"></div>
                                                            <div className="d-block fs-9 font-w400 text-end text-black">{datetime}</div>
                                                        </>
                                                        )}
                                                        {!isComplaint && (
                                                        <>
                                                            <div className='d-flex align-items-center mb-2'>
                                                            {item.image ? (
                                                                <img src={item.image} alt="Resolved Person" className='cursor-pointer rounded-pill w-35px h-35px' />
                                                            ):(
                                                                <img src={staff_img} alt="Resolved Person" className='cursor-pointer rounded-pill w-35px h-35px' />
                                                            )}
                                                            <div className='ms-1'>
                                                                <div className='text-info font-w400 fs-7'>{item.reason_provider_name}</div>
                                                                <div className="d-block fs-9 font-w400 text-end text-black">{datetime}</div>
                                                            </div>
                                                            </div>
                                                            <div className="border-bottom border-info mb-1"></div>
                                                            <div className="fs-8 font-w400 mb-1 text-black">{item.reason}</div>
                                                        </>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                            {!isComplaint && (
                                                <div className="border-bottom my-2"></div>
                                            )}
                                        </>
                                    );
                                })}
                            </div>
                        ) : (
                            <div className="text-center text-muted py-5">
                                <span className="fs-7">No conversation available</span>
                            </div>
                        )}

                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default ComplaintsSubscription;
